import styled from 'styled-components';

export const StyledWidget = styled.div`
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: ${({ theme }) => theme.size.palantir};
  font-weight: ${({ theme }) => theme.weight.regular};
  line-height: normal;
  color: ${({ theme }) => theme.color.grey12};
  text-align: left;

  * {
    box-sizing: border-box;
  }
`;
